var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-history",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3v5h5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7v5l4 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryWhite);
export default __webpack_public_path__ + "static/media/history-white.42ca5fc81be0e9a55efd127079f61983.svg";
export { ForwardRef as ReactComponent };